
import { fun } from '@/lib/request';
import { api } from '@/lib/env';
import { StateSlice } from '@/stores/appStore';
import { snakeToCamel } from '@/lib/utils';

export type FeatureGuide = {
  url: string;
  caption: string;
  description: string;
};

export type GuidesScene = 'Global' | 'PaperList' | 'Summarizes' | 'VIP';

export type FeaturesGuides = {
  type: 'features',
  value: FeatureGuide[],
};

export type GiftGuides = {
  type: 'gift',
  value: {
    url: string;
  },
}

export type CouponsGuides = {
  type: 'coupons',
  value: {
    url: string;
  },
}

export type AiColChargeGuides = {
  type: 'ai_col_charge',
  value: {
    url: string;
    height: number;
    width: number;
    description: string;
  },
}

export type ReceiveVipAlertGuides = {
  type: 'receive_vip_alert',
  value: {
    url: string;
    height: number;
    width: number;
    description: string;
  },
}

export type RechargeGuides = {
  type: 'recharge',
  value: {
    url: string;
  },
}

// 直接出来支付弹窗
export type BuyingGuides = {
  type: 'buying',
  value: {
  },
}

// 帮助弹窗
export type HelpGuides = {
  type: 'help',
  value: {
    title: string;
    image: string;
    subtitle: string;
    content: string;
    links: {
      label: string;
      url: string;
    }[];
  },
}


export type Guides = FeaturesGuides | GiftGuides | CouponsGuides | RechargeGuides | AiColChargeGuides | ReceiveVipAlertGuides | BuyingGuides | HelpGuides;


export type GuidesMap = Record<GuidesScene, {
  guides: Guides | null;
  _guidesInfo: GuidesInfo | null;
}>;

type GuideData = {
  key: string;
  version: string;
  content: Guides;
}


type GuidesInfo = Pick<GuideData, 'key' | 'version'>;

export type GuideSlice = {
  guides: Guides | null;
  _guidesInfo: GuidesInfo | null;
  // 之前没有考虑全局的情况，现在改个避免覆盖
  guidesMap: GuidesMap;
  fetchGuides: (scene: GuidesScene) => Promise<void>;
  markGuidesViewed: (scene: GuidesScene) => Promise<void>;
}

export const createGuideSlice: StateSlice<GuideSlice> = ((set, get) => ({
  guides: null,
  guidesMap: {} as GuidesMap,
  _guidesInfo: null,
  fetchGuides: async (scene) => {
    try {
      const formData = new FormData();
      formData.append('scene', scene);
      const { data, code } = (await fun.post(api('/common/getTips', true), formData)).data;
      if (code === 0) {
        set((state) => {
          const { content, ...rest } = snakeToCamel<GuideData>(data);
          state.guides = content;
          state._guidesInfo = rest;
          state.guidesMap[scene] = {
            guides: content,
            _guidesInfo: rest,
          };
        });
      }
    } catch (error) {
      console.error('Error fetch guides:', error);
    } finally {

    }
  },
  markGuidesViewed: async (scene) => {
    const { guidesMap } = get();
    const sceneGuidesInfo = guidesMap[scene]?._guidesInfo;
    if (sceneGuidesInfo) {
      const { key, version } = sceneGuidesInfo;
      if (key && version) {
        try {
          const formData = new FormData();
          formData.append('tips_key', key);
          formData.append('tips_version', version);
          const { data, code } = (await fun.post(api('/common/viewedTips', true), formData)).data;
          if (code === 0) {
            set((state) => {
              state.guides = null;
              state._guidesInfo = null;
              state.guidesMap[scene] = {
                guides: null,
                _guidesInfo: null,
              };
            });
          }
        } catch (error) {
          console.error('Error set guide viewed:', error);
        } finally {

        }
      }
    }
  }
}));
